import React from "react";
import { MainNavigationItem } from "./MainNavigationItem";
import { NavItem } from "./NavItem";

export type MainNavigationProps = {
    items?: NavItem[];
};

export const MainNavigation: React.FC<MainNavigationProps> = ({ items }) => {
    // Guard against undefined items during SSG
    if (!items || items.length === 0) {
        return null;
    }

    /*
     * `whitespace-nowrap` gegen die globale Wort-Trennung (3.8.2026).
     *
     * `src/index.css` setzt auf `body` ein `word-break: break-word` — als
     * Rueckfall fuer sehr lange Woerter ohne Trennwoerterbuch. Es vererbt sich
     * aber an ALLES, auch an Navigationspunkte, wo Trennung nie richtig ist:
     * gemessen brachen bei 1920px alle neun Punkte mitten im Wort
     * («Angebot/e», «Plattfor/m», «Deutsc/h») — nicht aus Platzmangel, der
     * Flex-Container hatte 805px fuer 82px Text.
     *
     * Zurueckgenommen wird das hier, nicht global: fuer Fliesstext ist die
     * Regel richtig, sie darf nur nicht bis in die Navigation durchgreifen.
     */
    return (
        <nav
            className="hidden xl:flex items-center gap-1 2xl:gap-2 whitespace-nowrap min-w-0"
            data-testid="main-navigation"
        >
            {items.map(item => (
                <MainNavigationItem item={item} key={item.href} />
            ))}
        </nav>
    );
};

export default MainNavigation;
